import React, { useRef, Fragment } from 'react';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'gatsby';
import { Text, Box } from '..';
import { useDetectOutsideClick } from '../../hooks';
import { theme } from '../../style';

const excludes = ['Feature', '特征', '特徴', '특징', 'Características'];

const Modal = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
`;

const MenuBox = styled(Box)`
  .menu-item {
    border-radius: 10px;
  }

  .link {
    text-decoration: none;
    font-family: ${theme.fonts.primary};
    color: ${theme.colors.grey.v6};
  }
`;

const Menu = ({ menu }) => {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={`dropdown ${isActive ? 'active' : ''}`}>
      <Button onClick={handleClick} className="button">
        {menu.name}
      </Button>

      {isActive && <Modal />}

      <MenuBox
        ref={dropdownRef}
        minWidth={excludes.includes(menu.name) && 500}
        className="dropdown-menu"
      >
        <Grid container spacing={1}>
          {Array.isArray(menu?.content) &&
            menu.content.map((menuItem, index) => (
              <Fragment key={index}>
                {menuItem && (
                  <Grid
                    item
                    xs={excludes.includes(menu.name) ? 6 : 12}
                    sm={excludes.includes(menu.name) ? 4 : 12}
                  >
                    {menuItem?.category && (
                      <Text color="grey.v7" fontWeight="bold" p={3}>
                        {menuItem.category}
                      </Text>
                    )}
                    {Array.isArray(menuItem?.items) &&
                      menuItem.items.map((value, i) => (
                        <MenuItem className="menu-item" key={i}>
                          <Link to={value.link} className="link">
                            {value.title}
                          </Link>
                        </MenuItem>
                      ))}
                  </Grid>
                )}
              </Fragment>
            ))}
        </Grid>
      </MenuBox>
    </div>
  );
};

export default Menu;
